import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
import { DeviceIdentityFieldsSchema } from './device-identity.js';
/** Human-initiated: dashboard requests a code to render as a QR code. */
export const CreatePairingCodeRequestSchema = z.object({
    screenId: z.string().min(1).optional(),
    ttlSeconds: z.number().int().positive().max(3600).optional(),
});
export const PairingCodeResponseSchema = z.object({
    code: z.string().min(1),
    expiresAt: IsoDateTimeSchema,
});
/** Device-initiated: player claims the code and receives its permanent identity. */
export const ClaimPairingCodeRequestSchema = z
    .object({
    code: z.string().min(1),
    deviceCode: z.string().min(1),
    appVersion: z.string().min(1).optional(),
})
    .merge(DeviceIdentityFieldsSchema);
export const ClaimPairingCodeResponseSchema = z.object({
    deviceId: z.string().min(1),
    screenId: z.string().nullable(),
    /** Bearer token — returned once, at claim time. The player stores it in secure storage. */
    token: z.string().min(1),
});
//# sourceMappingURL=pairing.js.map